import {
    SET_UPLOAD_PROGRESS,
    SET_UPLOAD_SUCCESS,
    SET_UPLOAD_FAILURE,
    SET_IMAGE_DATA,
    REMOVE_IMAGE,
    REMOVE_SEVERAL_UPLOADED_IMAGES,
    REMOVE_ALL,
} from '../actionTypes';
import {
    IMAGE_UPLOAD_REQUEST,
    IMAGE_UPLOAD_STATUS_UPLOADING,
    IMAGE_UPLOAD_STATUS_UPLOADED,
    IMAGE_UPLOAD_STATUS_FAILED,
    IMAGE_UPLOAD_COMPLETED,
} from "../constants"

const initialState = {
    hasErrors: false,
    uploadingImages: false,
    uploadingComplete: false,
    uploads: {},
    achievedUploads: {}
};

function uploadsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_IMAGE_DATA : {
            return Object.assign({}, state, {uploads: {...state.uploads, ...action.payload}, uploadingComplete: false})
        }
        case REMOVE_IMAGE : {
            const { [action.payload]: _, ...uploads } = state.uploads;
            return Object.assign({}, state, { uploads })
        }
        case REMOVE_ALL : {
            return Object.assign({},state,initialState)
        }
        case REMOVE_SEVERAL_UPLOADED_IMAGES: {
            const { filteredUploads, achievedUploads } =
                Object.entries(state.uploads).reduce((acc, [key, value]) =>
                    (action.payload.includes(value.filename)
                        ? (acc.achievedUploads[key] = value)
                        : (acc.filteredUploads[key] = value), acc), { filteredUploads: {}, achievedUploads: {} });
            return Object.assign({},state,{ uploads: filteredUploads, achievedUploads, uploadingComplete: false })
        }
        case IMAGE_UPLOAD_REQUEST: {
            return Object.assign({}, state, { uploadingImages: true , achievedUploads: {}, uploadingComplete: false , hasErrors: false });
        }
        case IMAGE_UPLOAD_COMPLETED: {
            return Object.assign({}, state, { uploadingImages: false  , uploadingComplete: true });
        }
        case SET_UPLOAD_PROGRESS:
            return {
                ...state,
                uploads: {
                    ...state.uploads,
                    [action.payload.fileName]: {
                        ...state.uploads[action.payload.fileName],
                        progress: action.payload.progress,
                        status: IMAGE_UPLOAD_STATUS_UPLOADING
                    }
                }
            };
        case SET_UPLOAD_SUCCESS:
            return {
                ...state,
                uploads: {
                    ...state.uploads,
                    [action.payload.fileName]: {
                        ...state.uploads[action.payload.fileName],
                        imageSrc: action.payload.imageSrc,
                        progress: 100,
                        status: IMAGE_UPLOAD_STATUS_UPLOADED
                    }
                }
            };
        case SET_UPLOAD_FAILURE:
            return {
                ...state,
                hasErrors: true,
                uploads: {
                    ...state.uploads,
                    [action.payload.fileName]: {
                        ...state.uploads[action.payload.fileName],
                        progress: 0,
                        status: IMAGE_UPLOAD_STATUS_FAILED,
                        error: action.payload.error.error
                    }
                }
            };
        default:
            return state;
    }
}

export default uploadsReducer;


// WEBPACK FOOTER //
// ./src/shared/redux/reducers/imageUploadReducer.js